import Page from "../components/page";
import React from "react";
import {Typography} from "@material-ui/core";
import {molabsStyles} from "../styles";

function Disclaimer() {
    const classes = molabsStyles();
    const image = require('../images/hero2.jpg?resize&sizes[]=1216&sizes[]=960&sizes[]=600&sizes[]=200');
    const webp = require('../images/hero2.jpg?resize&sizes[]=1216&sizes[]=960&sizes[]=600&sizes[]=200&format=webp');

    return (
        <Page
            image={image}
            webp={webp}
            title={"MoLabs Ltd. Privacy Policy"}
            description={"This privacy policy will explain how our organization uses the personal data we collect from you when you use our website."}
            metaTitle={"MoLabs Ltd. Privacy Policy"}
            noindex={true}>
            <div className={classes.contentContainer}>
                <Typography variant={"h2"} gutterBottom>
                    What data do we collect?
                </Typography>
                <Typography component={"p"} color={"textSecondary"} className={classes.marginBottom}>
                    MoLabs Ltd. collects the following data:
                    <ul>
                        <li>Personal identification information (Name, email address, phone number, etc.)</li>
                        <li>Job application specific Information</li>
                    </ul>
                </Typography>
                <Typography variant={"h2"} gutterBottom>
                    How do we collect your data?
                </Typography>
                <Typography component={"p"} color={"textSecondary"} className={classes.marginBottom}>
                    You directly provide MoLabs Ltd. with most of the data we collect. We collect data and process data when you:
                    <ul>
                        <li>Voluntarily complete our contact form</li>
                        <li>Apply for job postings</li>
                        <li>Use or view our website via your browser’s cookies</li>
                    </ul>
                </Typography>
                <Typography variant={"h2"} gutterBottom>
                    How will we use your data?
                </Typography>
                <Typography component={"p"} color={"textSecondary"} className={classes.marginBottom}>
                    MoLabs Ltd. collects your data so that we can:
                    <ul>
                        <li>We can reply to you about your interests in our organization.</li>
                        <li>Process your job application.</li>
                    </ul>
                </Typography>
                <Typography variant={"h2"} gutterBottom>
                    How do we store your data?
                </Typography>
                <Typography component={"p"} color={"textSecondary"} className={classes.marginBottom}>
                    MoLabs Ltd. securely stores your data at a data center in Frankfurt, Germany.
                </Typography>
                <Typography variant={"h2"} gutterBottom>
                    What are your data protection rights?
                </Typography>
                <Typography component={"p"} color={"textSecondary"} className={classes.marginBottom}>
                    MoLabs Ltd. would like to make sure you are fully aware of all of your data protection rights. Every user is entitled to the following:
                    <ul>
                        <li>The right to access – You have the right to request MoLabs Ltd. for copies of your personal data. We may charge you a small fee for this service.</li>
                        <li>The right to rectification – You have the right to request that MoLabs Ltd. correct any information you believe is inaccurate. You also have the right to request MoLabs Ltd. to complete the information you believe is incomplete.</li>
                        <li>The right to erasure – You have the right to request that MoLabs Ltd. erase your personal data, under certain conditions.</li>
                        <li>The right to restrict processing – You have the right to request that MoLabs Ltd. restrict the processing of your personal data, under certain conditions.</li>
                        <li>The right to object to processing – You have the right to object to MoLabs Ltd.’s processing of your personal data, under certain conditions.</li>
                        <li>The right to data portability – You have the right to request that MoLabs Ltd. transfer the data that we have collected to another organization, or directly to you, under certain conditions.</li>
                    </ul>
                    If you make a request, we have one month to respond to you. If you would like to exercise any of these rights, please contact us.<br />
                    <br />
                    Email us:<br />
                    contact@molabs.de<br />
                    <br />
                    Call us:<br />
                    +359 2 493 0255<br />
                    <br />
                    Or write to us:<br />
                    MoLabs Ltd.<br />
                    25 Vitosha Blvd., floor 2<br />
                    Sofia, Bulgaria<br />
                </Typography>
                <Typography variant={"h2"} gutterBottom>
                    Cookies
                </Typography>
                <Typography component={"p"} color={"textSecondary"} className={classes.marginBottom}>
                    Cookies are text files placed on your computer to collect standard Internet log information and visitor behavior information. When you visit our websites, we may collect information from you automatically through cookies or similar technology
                </Typography>
                <Typography variant={"h2"} gutterBottom>
                    How do we use cookies?
                </Typography>
                <Typography component={"p"} color={"textSecondary"} className={classes.marginBottom}>
                    MoLabs Ltd. uses cookies in a range of ways to improve your experience on our website, including:
                    <ul>
                        <li>Understanding how you use our website</li>
                        <li>Error tracking</li>
                    </ul>
                </Typography>
                <Typography variant={"h2"} gutterBottom>
                    How to manage cookies
                </Typography>
                <Typography component={"p"} color={"textSecondary"} className={classes.marginBottom}>
                    You can set your browser not to accept cookies. However, in a few cases, some of our website features may not function as a result.
                </Typography>
                <Typography variant={"h2"} gutterBottom>
                    Privacy policies of other websites
                </Typography>
                <Typography component={"p"} color={"textSecondary"} className={classes.marginBottom}>
                    The MoLabs Ltd. website contains links to other websites. Our privacy policy applies only to our website, so if you click on a link to another website, you should read their privacy policy.
                </Typography>
                <Typography variant={"h2"} gutterBottom>
                    Changes to our privacy policy
                </Typography>
                <Typography component={"p"} color={"textSecondary"} className={classes.marginBottom}>
                    MoLabs Ltd. keeps its privacy policy under regular review and places any updates on this web page. This privacy policy was last updated on 9 January 2019.
                </Typography>
                <Typography variant={"h2"} gutterBottom>
                    How to contact us
                </Typography>
                <Typography component={"p"} color={"textSecondary"} className={classes.marginBottom}>
                    If you have any questions about MoLabs Ltd.’s privacy policy, the data we hold on you, or you would like to exercise one of your data protection rights, please do not hesitate to contact us.<br />
                    <br />
                    Email us:<br />
                    contact@molabs.de<br />
                    <br />
                    Call us:<br />
                    +359 2 437 2246<br />
                    <br />
                    Or write to us:<br />
                    MoLabs Ltd.<br />
                    25 Vitosha Blvd., floor 2<br />
                    Sofia, Bulgaria<br />
                </Typography>
            </div>
        </Page>
    )
}

export default Disclaimer;
